import { Injectable, signal } from '@angular/core';

export interface Alert {
  id: string;
  message: string;
  type: 'success' | 'danger' | 'warning' | 'info';
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alerts = signal<Alert[]>([]);
  private timeouts = new Map<string, any>();

  getAlerts() {
    return this.alerts.asReadonly();
  }

  show(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'info', autoClose = type !== 'danger') {
    const id = `alert-${Date.now()}-${Math.random()}`;
    const alert: Alert = { id, message, type };
    
    this.alerts.update(alerts => [...alerts, alert]);
    
    if (autoClose) {
      // Auto-remove after 5 seconds
      const timeout = setTimeout(() => {
        this.remove(id);
        this.timeouts.delete(id);
      }, 5000);
      
      this.timeouts.set(id, timeout);
    }
  }

  remove(id: string) {
    // Clear timeout if it exists
    const timeout = this.timeouts.get(id);
    if (timeout) {
      clearTimeout(timeout);
      this.timeouts.delete(id);
    }
    this.alerts.update(alerts => alerts.filter(a => a.id !== id));
  }

  clear() {
    // Clear all timeouts
    this.timeouts.forEach(timeout => clearTimeout(timeout));
    this.timeouts.clear();
    this.alerts.set([]);
  }
}
